/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../client/js/components/NoData'
import SelectionToggle from '../../../client/js/components/selection/SelectionToggle'
import RoleListItem from './RoleListItem'

export type RoleListProps = {
  items: Role[]
}

function RoleList (props: RoleListProps) {
  const { items } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th style={{ width: 50 }}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th scope="col">
            <FormattedMessage
              id="name"
              defaultMessage="Nom"
            />
          </Table.Th>
          <Table.Th
            scope="col"
            style={{ width: 100 }}
          >
            <FormattedMessage
              id="type"
              defaultMessage="Type"
            />
          </Table.Th>
          <Table.Th
            scope="col"
            style={{ width: 200 }}
          >
            <FormattedMessage
              id="created_at"
              defaultMessage="Créé le"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <RoleListItem
              item={item}
              key={item.id}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={4}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default RoleList
